import type { OrderBadge } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { orderBadgeLabels } from '@/shared/lib';
import { StatusBadge } from '@/shared/ui';
import { ORDER_BADGE_TONES } from '../model/status-tone';

interface OrderFlagBadgeProps {
  readonly badge: OrderBadge;
}

/** 처리 필요 배지(취소 요청·지연·추적 실패 등) — 상태 배지와 같은 점 + 글자 알약. */
export const OrderFlagBadge = ({ badge }: OrderFlagBadgeProps): ReactElement => (
  <StatusBadge tone={ORDER_BADGE_TONES[badge]}>{orderBadgeLabels[badge]}</StatusBadge>
);
